import { Button, styled } from "@mui/material";
import colors from "../../theme/themeConstants";

export const UnFollowButton = styled(Button)({
  height: "52px",
  width: "100%",
  margin: "1.5rem 0rem",
  borderRadius: "38px",
  background: "transparent",
  border: `1px solid ${colors.purple}`,
  fontFamily: "'Poppins', sans-serif",
  color: "white",
  ":hover": { border: `1px solid ${colors.purple}` }
});

export const FollowButton = styled(Button)({
  height: "52px",
  width: "100%",
  margin: "1.5rem 0rem",
  borderRadius: "38px",
  background: colors.purpleGradient,
  border: `1px solid ${colors.purple}`,
  fontFamily: "'Poppins', sans-serif",
  color: "white",
  ":hover": { border: `1px solid ${colors.purple}` },
  ":disabled": { color: "white" }
});
